import { fromPromise } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import _ from 'lodash';
import { appSliceActions, appStateSelectors, reduxStore } from '../redux';
import { apolloClient } from '.';

const refreshAuth = async () => {
  const state = reduxStore.getState();
  const { refreshToken: refreshTokenOld, clientId } = appStateSelectors.getAppState(state) ?? {};
  const uri = appStateSelectors.getRefreshTokenURL(state);

  if (refreshTokenOld && clientId) {
    try {
      const data = await fetch(uri, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ refreshToken: refreshTokenOld, clientId }),
      });

      const jason = await data.json();
      const { accessToken, idToken, refreshToken, expires, clients } = jason?.result ?? jason ?? {};

      reduxStore.dispatch(
        appSliceActions.setAuth({
          accessToken,
          idToken,
          refreshToken: refreshToken ?? refreshTokenOld,
          expires: new Date(expires),
          clients,
        })
      );
      return appStateSelectors.getAuthorizationToken(reduxStore.getState());
    } catch (err) {
      await apolloClient.clearStore();
      reduxStore.dispatch(appSliceActions.logOut());
    }
  }
  return _.stubString();
};

export const onErrorLink = onError(({ graphQLErrors, networkError, operation, forward }) => {
  if (graphQLErrors && operation.operationName !== 'login') {
    for (let err of graphQLErrors) {
      switch (err?.extensions?.code) {
        case 'UNAUTHENTICATED':
          return fromPromise(refreshAuth())
            .map((authorization) => {
              const oldHeaders = operation.getContext().headers;
              operation.setContext({
                headers: {
                  ...oldHeaders,
                  authorization,
                },
              });
              return operation;
            })
            .flatMap(forward);
        default:
          return forward(operation);
      }
    }
  }
  // To retry on network errors, we recommend the RetryLink
  // instead of the onError link. This just logs the error
  if (networkError) {
    console.log(`[Network error]: ${networkError}`);
  }
  return forward(operation);
});
